@if (isOpen()) {
  <div
    (click)="close()"
    class="fixed inset-0 z-50 flex items-center justify-center p-3 sm:p-6 overflow-y-auto bg-slate-950/75 backdrop-blur-xs transition-opacity cursor-pointer"
  >
    <!-- Modal Container -->
    <div
      (click)="$event.stopPropagation()"
      class="relative w-full max-w-3xl bg-white dark:bg-slate-900 rounded-2xl shadow-2xl border border-slate-200 dark:border-slate-800 overflow-hidden z-10 transition-colors my-auto cursor-default text-left flex flex-col max-h-[92vh] sm:max-h-[90vh]"
    >
      <!-- Modal Header -->
      <div class="px-5 py-3.5 sm:py-4 border-b border-slate-100 dark:border-slate-800 flex items-center justify-between bg-slate-50/80 dark:bg-slate-950/50 shrink-0">
        <div class="flex items-center space-x-3">
          <div class="w-10 h-10 rounded-xl bg-emerald-600/10 dark:bg-emerald-500/20 text-emerald-700 dark:text-emerald-400 flex items-center justify-center shadow-2xs">
            <app-icon name="shield" [size]="20" />
          </div>
          <div>
            <h3 class="text-base font-bold text-slate-900 dark:text-white flex items-center gap-2">
              <span>Personalizar escudo</span>
            </h3>
            <p class="text-xs text-slate-500 dark:text-slate-400">
              Colores y siglas oficiales
            </p>
          </div>
        </div>

        <button
          type="button"
          (click)="close()"
          id="btn-close-shield-editor"
          class="p-1.5 rounded-xl text-slate-400 hover:text-slate-700 dark:hover:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-800 cursor-pointer transition-colors"
          aria-label="Cerrar editor"
        >
          <app-icon name="x" [size]="18" />
        </button>
      </div>

      <!-- Loading State -->
      @if (loading()) {
        <div class="py-20 text-center space-y-3 flex flex-col items-center justify-center">
          <div class="w-9 h-9 border-3 border-emerald-600 border-t-transparent rounded-full animate-spin"></div>
          <p class="text-xs font-bold text-slate-700 dark:text-slate-300">Cargando configuración del escudo…</p>
          <p class="text-[11px] text-slate-400">Consultando plantilla y colores asignados al club.</p>
        </div>
      } @else {
        <!-- Mobile Pinned Live Preview Header (Centered shield preview without extra text) -->
        <div class="md:hidden shrink-0 py-3 bg-slate-50/95 dark:bg-slate-950/95 border-b border-slate-200/90 dark:border-slate-800 shadow-2xs z-20 flex items-center justify-center">
          <div class="w-20 h-24 flex items-center justify-center filter drop-shadow-md">
            <app-club-shield
              [shield]="previewShield()"
              size="custom"
              customClass="w-full h-full"
            />
          </div>
        </div>

        <!-- Content Body: Scrollable area with controls and desktop column -->
        <div class="p-4 sm:p-6 space-y-5 max-h-[72vh] md:max-h-[78vh] overflow-y-auto">
          <!-- Authorization Alert if not administrator -->
          @if (!isAuthorized()) {
            <div class="p-3.5 rounded-xl bg-amber-50 border border-amber-200 text-amber-900 dark:bg-amber-950/40 dark:border-amber-800 dark:text-amber-300 text-xs flex items-start gap-2.5">
              <app-icon name="alert-triangle" [size]="16" class="shrink-0 text-amber-600 dark:text-amber-400 mt-0.5" />
              <div>
                <strong class="font-bold">Modo solo lectura:</strong>
                <span> No tienes permisos de administración sobre este club. Solo su mánager oficial puede modificar el escudo.</span>
              </div>
            </div>
          }

          <!-- Success Alert -->
          @if (success()) {
            <div class="p-3.5 rounded-xl bg-emerald-50 border border-emerald-200 text-emerald-900 dark:bg-emerald-950/40 dark:border-emerald-800 dark:text-emerald-300 text-xs flex items-center justify-between">
              <div class="flex items-center gap-2">
                <app-icon name="check-circle" [size]="16" class="text-emerald-600 dark:text-emerald-400" />
                <span class="font-bold">{{ serverNotice() || 'Configuración guardada correctamente' }}</span>
              </div>
            </div>
          }

          <!-- Error Alert -->
          @if (error()) {
            <div class="p-3.5 rounded-xl bg-rose-50 border border-rose-200 text-rose-900 dark:bg-rose-950/40 dark:border-rose-800 dark:text-rose-300 text-xs flex items-start gap-2">
              <app-icon name="alert-circle" [size]="16" class="shrink-0 text-rose-600 dark:text-rose-400 mt-0.5" />
              <span>{{ error() }}</span>
            </div>
          }

          <div class="grid grid-cols-1 md:grid-cols-12 gap-6 items-start">
            <!-- Left Column: Desktop Live Preview (hidden on mobile, sticky on desktop) -->
            <div class="hidden md:flex md:col-span-5 flex-col items-center md:sticky md:top-0 md:self-start">
              <div class="w-full bg-slate-50 dark:bg-slate-950/60 p-5 rounded-2xl border border-slate-200 dark:border-slate-800 flex flex-col items-center justify-center text-center shadow-xs">
                <span class="text-[10px] font-bold uppercase tracking-wider text-slate-400 dark:text-slate-500 mb-3">
                  Tu escudo
                </span>

                <!-- Shield Preview Container -->
                <div class="w-36 h-44 sm:w-44 sm:h-52 my-2 flex items-center justify-center filter drop-shadow-md">
                  <app-club-shield
                    [shield]="previewShield()"
                    size="custom"
                    customClass="w-full h-full"
                  />
                </div>

                <!-- Info Badges 
                <div class="mt-4 pt-3 border-t border-slate-200/70 dark:border-slate-800 w-full flex items-center justify-around text-[11px]">
                  <div class="flex items-center gap-1.5" title="Color Principal">
                    <span class="w-3.5 h-3.5 rounded-full border border-black/10 dark:border-white/20 shadow-2xs" [style.backgroundColor]="currentPrimaryColor()"></span>
                    <span class="font-mono text-slate-600 dark:text-slate-400 font-semibold">{{ currentPrimaryColor() }}</span>
                  </div>
                  <div class="flex items-center gap-1.5" title="Color Secundario">
                    <span class="w-3.5 h-3.5 rounded-full border border-black/10 dark:border-white/20 shadow-2xs" [style.backgroundColor]="currentSecondaryColor()"></span>
                    <span class="font-mono text-slate-600 dark:text-slate-400 font-semibold">{{ currentSecondaryColor() }}</span>
                  </div>
                  <div class="flex items-center gap-1.5" title="Color del texto">
                    <span class="w-3.5 h-3.5 rounded-full border border-black/10 dark:border-white/20 shadow-2xs" [style.backgroundColor]="currentTextColor()"></span>
                    <span class="font-mono text-slate-600 dark:text-slate-400 font-semibold">{{ currentTextColor() }}</span>
                  </div>
                  <span class="font-mono font-bold px-2 py-0.5 rounded bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-slate-800 dark:text-slate-200">
                    {{ currentInitials() }}
                  </span>
                </div>-->
              </div>

              <!-- Quick Palette Presets (Desktop) -->
              <div class="w-full mt-3 p-3 bg-white dark:bg-slate-900 rounded-xl border border-slate-200 dark:border-slate-800">
                <div class="text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-2">
                  Paletas Rápidas
                </div>
                <div class="grid grid-cols-2 gap-1.5">
                  @for (preset of presets; track preset.name) {
                    <button
                      type="button"
                      (click)="applyPreset(preset)"
                      [disabled]="!isAuthorized()"
                      class="flex items-center gap-2 p-1.5 rounded-lg border border-slate-200/80 dark:border-slate-800 hover:bg-slate-50 dark:hover:bg-slate-800/60 transition-colors text-left cursor-pointer disabled:opacity-50 text-[11px]"
                    >
                      <div class="flex items-center -space-x-1 shrink-0">
                        <span class="w-3.5 h-3.5 rounded-full border border-white dark:border-slate-900" [style.backgroundColor]="preset.primary"></span>
                        <span class="w-3.5 h-3.5 rounded-full border border-white dark:border-slate-900" [style.backgroundColor]="preset.secondary"></span>
                      </div>
                      <span class="truncate text-slate-700 dark:text-slate-300 font-medium">{{ preset.name }}</span>
                    </button>
                  }
                </div>
              </div>
            </div>

            <!-- Right Column: Customization Controls Form (Full width on mobile, col-span-7 on desktop) -->
            <div class="md:col-span-7 space-y-4">
              <!-- Quick Palette Presets (Mobile Only: directly accessible in form) -->
              <div class="md:hidden p-3 bg-slate-50 dark:bg-slate-950/40 rounded-xl border border-slate-200 dark:border-slate-800">
                <div class="text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-2">
                  Paletas Rápidas
                </div>
                <div class="grid grid-cols-2 gap-1.5">
                  @for (preset of presets; track preset.name) {
                    <button
                      type="button"
                      (click)="applyPreset(preset)"
                      [disabled]="!isAuthorized()"
                      class="flex items-center gap-2 p-1.5 rounded-lg border border-slate-200/80 dark:border-slate-800 bg-white dark:bg-slate-900 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors text-left cursor-pointer disabled:opacity-50 text-[11px]"
                    >
                      <div class="flex items-center -space-x-1 shrink-0">
                        <span class="w-3.5 h-3.5 rounded-full border border-white dark:border-slate-900" [style.backgroundColor]="preset.primary"></span>
                        <span class="w-3.5 h-3.5 rounded-full border border-white dark:border-slate-900" [style.backgroundColor]="preset.secondary"></span>
                      </div>
                      <span class="truncate text-slate-700 dark:text-slate-300 font-medium">{{ preset.name }}</span>
                    </button>
                  }
                </div>
              </div>

              <form [formGroup]="form" (ngSubmit)="saveConfig()" class="space-y-4">
                <!-- 1. Template Selection -->
                <div class="space-y-1.5">
                  <label class="text-xs font-bold uppercase tracking-wider text-slate-700 dark:text-slate-300 flex items-center justify-between">
                    <span>1. Plantilla de Escudo</span>
                    <span class="text-[10px] font-normal text-slate-400">{{ allTemplates().length }} plantillas disponibles</span>
                  </label>

                  @if (!allTemplates().length) {
                    <p role="status" class="text-sm text-slate-500">No hay plantillas de escudo disponibles.</p>
                  }
                  <div class="grid grid-cols-3 sm:grid-cols-4 gap-2">
                    @for (template of allTemplates(); track template.id) {
                      <button
                        type="button"
                        (click)="selectTemplate(template)"
                        [disabled]="!template.available || !isAuthorized()"
                        [id]="'shield-template-option-' + template.id"
                        [attr.aria-label]="template.name"
                        [title]="template.name"
                        class="p-2.5 rounded-xl border flex flex-col items-center justify-center gap-1.5 transition-all text-center relative cursor-pointer disabled:cursor-not-allowed"
                        [ngClass]="[
                          form.controls.templateId.value === template.id
                            ? 'bg-emerald-50 dark:bg-emerald-950/40 border-emerald-500 text-emerald-800 dark:text-emerald-300 ring-2 ring-emerald-500/30 font-bold'
                            : template.available
                              ? 'bg-white dark:bg-slate-800/80 border-slate-200 dark:border-slate-700 text-slate-700 dark:text-slate-300 hover:border-slate-300 dark:hover:border-slate-600'
                              : 'bg-slate-100/60 dark:bg-slate-950/40 border-slate-200/50 dark:border-slate-800/50 text-slate-400 dark:text-slate-600 opacity-60'
                        ]"
                      >
                        <div class="w-10 h-12 flex items-center justify-center">
                          @if (template.available) {
                            <app-club-shield
                              [templateId]="template.id"
                              [originalTemplate]="true"
                              [secondaryColor]="template.defaultSecondaryColor"
                              [initials]="template.defaultInitials"
                              size="custom"
                            />
                          } @else {
                            <app-icon name="shield" [size]="18" class="text-slate-300 dark:text-slate-600" />
                          }
                        </div>
                        @if (!template.available) {
                          <span class="text-[8px] uppercase tracking-tight text-slate-400">Pronto</span>
                        }
                      </button>
                    }
                  </div>
                </div>

                <!-- 2. Primary Color (Hex Picker) -->
                <div class="space-y-1.5 pt-2 border-t border-slate-100 dark:border-slate-800">
                  <label for="shield-primary-color-text" class="text-xs font-bold uppercase tracking-wider text-slate-700 dark:text-slate-300 flex items-center justify-between">
                    <span>2. Color Principal</span>
                  </label>

                  <div class="flex items-center gap-2">
                    <!-- HTML5 Color Swatch Input -->
                    <div class="relative w-11 h-10 rounded-xl overflow-hidden border border-slate-300 dark:border-slate-700 shrink-0 shadow-2xs">
                      <input
                        type="color"
                        [formControl]="form.controls.primaryColor"
                        id="shield-primary-color-native"
                        class="absolute -inset-2 w-16 h-16 cursor-pointer border-0 p-0"
                        [disabled]="!isAuthorized()"
                        title="Seleccionar color con cuentagotas"
                      />
                    </div>
                    <!-- Hex Text Input -->
                    <div class="relative flex-1">
                      <span class="absolute inset-y-0 left-3 flex items-center text-slate-400 font-mono text-xs">#</span>
                      <input
                        type="text"
                        [value]="form.controls.primaryColor.value.replace('#', '')"
                        (input)="form.controls.primaryColor.setValue('#' + $any($event.target).value.replace('#', ''))"
                        id="shield-primary-color-text"
                        maxlength="6"
                        placeholder="123D83"
                        [disabled]="!isAuthorized()"
                        class="w-full pl-7 pr-3 py-2 text-xs font-mono font-bold uppercase rounded-xl border bg-white dark:bg-slate-800 text-slate-900 dark:text-white border-slate-200 dark:border-slate-700 focus:outline-none focus:ring-2 focus:ring-emerald-500"
                      />
                    </div>
                  </div>
                  @if (form.controls.primaryColor.touched && form.controls.primaryColor.invalid) {
                    <p class="text-[11px] text-rose-500 font-medium">Introduce un formato hexadecimal válido (ej. #123D83).</p>
                  }
                </div>

                <!-- 3. Secondary Color (Hex Picker) -->
                <div class="space-y-1.5 pt-2 border-t border-slate-100 dark:border-slate-800">
                  <label for="shield-secondary-color-text" class="text-xs font-bold uppercase tracking-wider text-slate-700 dark:text-slate-300 flex items-center justify-between">
                    <span>3. Color Secundario</span>
                  </label>

                  <div class="flex items-center gap-2">
                    <!-- HTML5 Color Swatch Input -->
                    <div class="relative w-11 h-10 rounded-xl overflow-hidden border border-slate-300 dark:border-slate-700 shrink-0 shadow-2xs">
                      <input
                        type="color"
                        [formControl]="form.controls.secondaryColor"
                        id="shield-secondary-color-native"
                        class="absolute -inset-2 w-16 h-16 cursor-pointer border-0 p-0"
                        [disabled]="!isAuthorized()"
                        title="Seleccionar color con cuentagotas"
                      />
                    </div>
                    <!-- Hex Text Input -->
                    <div class="relative flex-1">
                      <span class="absolute inset-y-0 left-3 flex items-center text-slate-400 font-mono text-xs">#</span>
                      <input
                        type="text"
                        [value]="form.controls.secondaryColor.value.replace('#', '')"
                        (input)="form.controls.secondaryColor.setValue('#' + $any($event.target).value.replace('#', ''))"
                        id="shield-secondary-color-text"
                        maxlength="6"
                        placeholder="F5B800"
                        [disabled]="!isAuthorized()"
                        class="w-full pl-7 pr-3 py-2 text-xs font-mono font-bold uppercase rounded-xl border bg-white dark:bg-slate-800 text-slate-900 dark:text-white border-slate-200 dark:border-slate-700 focus:outline-none focus:ring-2 focus:ring-emerald-500"
                      />
                    </div>
                  </div>
                  @if (form.controls.secondaryColor.touched && form.controls.secondaryColor.invalid) {
                    <p class="text-[11px] text-rose-500 font-medium">Introduce un formato hexadecimal válido (ej. #F5B800).</p>
                  }
                </div>

                <!-- 4. Text Color (Hex Picker) -->
                <div class="space-y-1.5 pt-2 border-t border-slate-100 dark:border-slate-800">
                  <label for="shield-text-color-text" class="text-xs font-bold uppercase tracking-wider text-slate-700 dark:text-slate-300 flex items-center justify-between">
                    <span>4. Color del Texto</span>
                  </label>

                  <div class="flex items-center gap-2">
                    <!-- HTML5 Color Swatch Input -->
                    <div class="relative w-11 h-10 rounded-xl overflow-hidden border border-slate-300 dark:border-slate-700 shrink-0 shadow-2xs">
                      <input
                        type="color"
                        [formControl]="form.controls.textColor"
                        id="shield-text-color-native"
                        class="absolute -inset-2 w-16 h-16 cursor-pointer border-0 p-0"
                        [disabled]="!isAuthorized()"
                        title="Seleccionar color del texto"
                      />
                    </div>
                    <!-- Hex Text Input -->
                    <div class="relative flex-1">
                      <span class="absolute inset-y-0 left-3 flex items-center text-slate-400 font-mono text-xs">#</span>
                      <input
                        type="text"
                        [value]="form.controls.textColor.value.replace('#', '')"
                        (input)="form.controls.textColor.setValue('#' + $any($event.target).value.replace('#', ''))"
                        id="shield-text-color-text"
                        maxlength="6"
                        placeholder="FFFFFF"
                        [disabled]="!isAuthorized()"
                        class="w-full pl-7 pr-3 py-2 text-xs font-mono font-bold uppercase rounded-xl border bg-white dark:bg-slate-800 text-slate-900 dark:text-white border-slate-200 dark:border-slate-700 focus:outline-none focus:ring-2 focus:ring-emerald-500"
                      />
                    </div>
                  </div>
                  @if (form.controls.textColor.touched && form.controls.textColor.invalid) {
                    <p class="text-[11px] text-rose-500 font-medium">Introduce un formato hexadecimal válido (ej. #FFFFFF).</p>
                  }
                </div>

                <!-- 5. Club Initials (Optional, up to 3 letters or numbers) -->
                <div class="space-y-1.5 pt-2 border-t border-slate-100 dark:border-slate-800">
                  <label for="shield-initials-input" class="text-xs font-bold uppercase tracking-wider text-slate-700 dark:text-slate-300 flex items-center justify-between">
                    <span>5. Siglas del club</span>
                  </label>

                  <div class="relative">
                    <input
                      type="text"
                      [value]="form.controls.initials.value"
                      (input)="onInitialsInput($event)"
                      id="shield-initials-input"
                      maxlength="3"
                      placeholder="LOM"
                      [disabled]="!isAuthorized()"
                      class="w-full px-3.5 py-2.5 text-sm font-mono font-black tracking-widest uppercase rounded-xl border bg-white dark:bg-slate-800 text-slate-900 dark:text-white border-slate-200 dark:border-slate-700 focus:outline-none focus:ring-2 focus:ring-emerald-500"
                    />
                    <div class="absolute inset-y-0 right-3 flex items-center text-xs font-mono font-bold" [ngClass]="form.controls.initials.valid ? 'text-emerald-600 dark:text-emerald-400' : 'text-slate-400'">
                      {{ form.controls.initials.value.length }}/3
                    </div>
                  </div>
                  @if (form.controls.initials.touched && form.controls.initials.invalid) {
                    <p class="text-[11px] text-rose-500 font-medium">Usa hasta 3 letras o números, o deja el campo vacío.</p>
                  }
                </div>

                <!-- Actions Footer -->
                <div class="pt-4 border-t border-slate-200 dark:border-slate-800 flex items-center justify-end gap-2.5">
                  <button
                    type="button"
                    (click)="close()"
                    [disabled]="saving()"
                    id="btn-cancel-shield-editor"
                    class="px-4 py-2 text-xs font-semibold rounded-xl border border-slate-200 dark:border-slate-700 text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800 cursor-pointer transition-colors"
                  >
                    Cancelar
                  </button>

                  <button
                    type="submit"
                    [disabled]="form.invalid || loading() || !allTemplates().length || saving() || !isAuthorized()"
                    id="btn-save-club-shield"
                    class="px-5 py-2 text-xs font-bold rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white shadow-xs cursor-pointer transition-all flex items-center gap-1.5 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    @if (saving()) {
                      <span class="w-3.5 h-3.5 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                      <span>Guardando…</span>
                    } @else {
                      <app-icon name="check" [size]="15" />
                      <span>Guardar escudo</span>
                    }
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
}
